import { createAction } from 'redux-act';
// add Designation action
const addDesignationRequest = createAction('ADD_DESIGNATION_REQUEST', data => data);
const addDesignationSuccess = createAction('ADD_DESIGNATION_SUCCESS', data => data);
const addDesignationError = createAction('ADD_DESIGNATION_ERROR');

// get Designation action
const getAllDesignationRequest = createAction('GET_ALL_DESIGNATION_REQUEST', data => data);
const getAllDesignationSuccess = createAction('GET_ALL_DESIGNATION_SUCCESS', data => data);
const getAllDesignationError = createAction('GET_ALL_DESIGNATION_ERROR');

// get Designation bY Department action
const getDesignationsByDepartmentRequest = createAction('GET_DESIGNATION_BY_DEPARTMENT_REQUEST', data => data);
const getDesignationsByDepartmentSuccess = createAction('GET_DESIGNATION_BY_DEPARTMENT_SUCCESS', data => data);
const getDesignationsByDepartmentError = createAction('GET_DESIGNATION_BY_DEPARTMENT_ERROR');

// Update Designation action
const updateDesignationRequest = createAction('Update_DESIGNATION_REQUEST', data => data);
const updateDesignationSuccess = createAction('Update_DESIGNATION_SUCCESS', data => data);
const updateDesignationError = createAction('Update_DESIGNATION_ERROR');

// Delete Designation action
const deleteDesignationRequest = createAction('Delete_DESIGNATION_REQUEST', data => data);
const deleteDesignationSuccess = createAction('Delete_DESIGNATION_SUCCESS', data => data);
const deleteDesignationError = createAction('Delete_DESIGNATION_ERROR');

// clear existing Designation action
const handleClearDesignationStore = createAction('HANDLE_CLEAR_DESIGNATION_STORE',data => data);
// const toastMsgAction = createAction('SUCCESS', data=> data);

export default {
    addDesignationRequest,
    addDesignationSuccess,
    addDesignationError,

    getAllDesignationRequest,
    getAllDesignationSuccess,
    getAllDesignationError,

    getDesignationsByDepartmentRequest,
    getDesignationsByDepartmentSuccess,
    getDesignationsByDepartmentError,

    updateDesignationRequest,
    updateDesignationSuccess,
    updateDesignationError,

    deleteDesignationRequest,
    deleteDesignationSuccess,
    deleteDesignationError,
    
    handleClearDesignationStore,
    // toastMsgAction,
    
}